import { ErrorHandler, inject } from '@angular/core';
import { ViewTransitionInfo } from '@angular/router';

export function onViewTransitionCreated({ transition }: ViewTransitionInfo): void {
  const errorHandler = inject(ErrorHandler);

  transition.ready.catch(() => undefined);
  transition.updateCallbackDone.catch(() => undefined);
  transition.finished.catch((reason: unknown) => {
    const error = reason instanceof Error
      ? reason
      : new Error(`Router view transition failed: ${String(reason)}`);

    errorHandler.handleError(error);
  });
}
